import centralRegion from 'assets/images/icons/campaign-data-collection/central-region.png';
import north from 'assets/images/icons/campaign-data-collection/north.png';
import south from 'assets/images/icons/campaign-data-collection/south.png';
import male from 'assets/images/icons/campaign-data-collection/male.png';
import female from 'assets/images/icons/campaign-data-collection/female.png';

export const listAddress = [
    { value: 60, label: 'Thành phố Hồ Chí Minh', image: south },
    { value: 17, label: 'Đà Nẵng', image: centralRegion },
    { value: 26, label: 'Hà Nội', image: north },
];

export const listGender = [
    { value: 1, label: 'Nam', image: male },
    { value: 2, label: 'Nữ', image: female },
];

export const listAge = [
    {
        value: '0-14',
        description: '10-14 tuổi',
        label: 'Học sinh cấp 2',
    },
    {
        value: '23-25',
        description: '23-25 tuổi',
        label: 'Mới đi làm',
    },
    {
        value: '15-17',
        description: '15-17 tuổi',
        label: 'Học sinh cấp 3',
    },
    {
        value: '26-30',
        description: '26-30 tuổi',
        label: 'Có kinh nghiệm làm việc',
    },
    {
        value: '18-22',
        description: '18-22 tuổi',
        label: 'Sinh viên',
    },
    {
        value: '31-1000',
        description: 'Trên 30 tuổi',
        label: 'Ổn định sự nghiệp',
    },
];

export const listMaritalStatus = [
    {
        value: 66,
        label: 'Độc thân',
    },
    {
        value: 67,
        label: 'Đã kết hôn',
    },
];

export const listChildrens = [
    {
        value: 68,
        label: 'Chưa có con',
    },
    {
        value: 69,
        label: 'Đã có con',
    },
];

export const listFields = [
    { value: 81, label: 'Vận tải - Logistic' },
    { value: 82, label: 'Bảo hiểm' },
    { value: 83, label: 'Bán lẻ' },
    { value: 84, label: 'Du lịch - Nhà hàng - Khách sạn' },
    { value: 85, label: 'Bất động sản - Xây dựng' },
    { value: 86, label: 'F&B' },
    { value: 87, label: 'Ô tô - Xe máy' },
    { value: 88, label: 'Viễn thông' },
    { value: 89, label: 'Tài chính - Ngân hàng' },
    { value: 90, label: 'Công nghệ' },
    { value: 91, label: 'FMCG' },
    { value: 92, label: 'Chăm sóc sức khoẻ' },
    { value: 93, label: 'Y tế' },
    // { value: 94, label: 'Khác' },
];

export const listJobs = [
    { value: 70, label: 'Công chức nhà nước' },
    { value: 71, label: 'Nhân viên văn phòng công ty tư nhân' },
    { value: 72, label: 'Chủ doanh nghiệp/Doanh nhân' },
    { value: 73, label: 'Tự kinh doanh riêng' },
    { value: 74, label: 'Lao động trình độ cao (Bác sĩ, kỹ sư, luật sư, ...)' },
    { value: 75, label: 'Freelancer' },
    { value: 76, label: 'Sinh viên' },
    { value: 77, label: 'Công nhân' },
    { value: 78, label: 'Nông dân' },
    { value: 79, label: 'Nội trợ / hưu trí' },
    // { value: 80, label: 'Khác' },
];

export const listIncome = [
    {
        value: '0-9999999',
        label: 'Dưới 10 triệu VND/tháng',
    },
    {
        value: '10000000-29999999',
        label: 'Từ 10 - dưới 30 triệu VND/tháng',
    },
    {
        value: '30000000-59999999',
        label: 'Từ 30 - dưới 60 triệu VND/tháng',
    },
    {
        value: '60000000-0',
        label: 'Trên 60 triệu VND/tháng',
    },
];
